let load_more_btn = document.getElementsByClassName('load-more_btn')[0];
let load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

async function loadMoreProducts() {
    let products_on_page = document.getElementById('product-grid');
    let next_url = products_on_page && products_on_page.dataset.nextUrl;
    if (!next_url) return;

    async function getNextPage() {
      try {
        let res = await fetch(next_url);
        return await res.text();
      } catch (error) {
        console.log(error);
      }
    }
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'flex';
    let nextPage = await getNextPage();

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    load_more_spinner.style.display = 'none';

    const productgrid = nextPageDoc.getElementById('product-grid');
    if (!productgrid) return;
    const new_products = productgrid.getElementsByClassName('grid__item');
    const new_url_next = productgrid.dataset.nextUrl;
  
    const existingHandles = new Set(
      Array.from(products_on_page.querySelectorAll('.card-wrapper[data-handle]'))
        .map(el => el.dataset.handle)
    );
    for (let i = 0; i < new_products.length; i++) {
      const handle = new_products[i].querySelector('.card-wrapper[data-handle]')?.dataset.handle;
      if (handle && existingHandles.has(handle)) continue;
      let single_product = new_products[i].cloneNode(true);
      products_on_page.appendChild(single_product);
      if (handle) existingHandles.add(handle);
    }

    loadProducts();
    setTimeout(() => { if (typeof applyAvailabilityFilter === 'function') applyAvailabilityFilter(); }, 50);
    const productGridcs = document.getElementById('product-grid');
    if (new_url_next) {
      if (productGridcs) {
        productGridcs.removeAttribute('data-next-url');
        productGridcs.setAttribute('data-next-url', new_url_next);
      }
      load_more_btn.style.display = 'flex';
    } else {
        productGridcs.removeAttribute('data-next-url');
        load_more_btn.style.display = 'none';
    }
    return new_url_next
}

